import { Cell, Pie, Tooltip, PieChart, ResponsiveContainer } from "recharts";
import { useIntl } from "react-intl";
import { Fonts } from "@lib/constants/AppEnums";
import { useMemo } from "react";
import { Grid, Spin } from "antd";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { PieChartData } from "..";

const { useBreakpoint } = Grid;

type Props = {
  loading?: boolean;
  data: PieChartData[];
};

export default function Graph1({ data, loading }: Props) {
  const { messages } = useIntl();
  const total = useMemo(() => {
    let count = 0;
    for (let index = 0; index < data.length; index++) {
      count += data[index].value;
    }
    return count;
  }, [data]);

  const screens = useBreakpoint();
  const height = useMemo(() => {
    if (screens.xl) return 200;
    if (screens.lg) return 200;
    if (screens.sm) return 200;
    return 150;
  }, [screens]);

  const cells = data.filter((f) => f.value > 0);

  if (loading) {
    return (
      <StyledFlex style={{ justifyContent: "center" }}>
        <Spin />
      </StyledFlex>
    );
  }

  return (
    <StyledFlex style={{ height: `${height}px` }}>
      <ResponsiveContainer>
        <PieChart>
          <text
            x="50%"
            fontWeight={Fonts.MEDIUM}
            fontSize={15}
            y="45%"
            textAnchor="middle"
            dominantBaseline="middle"
          >
            {messages["common.total"] as string}
          </text>
          <text
            x="50%"
            fontWeight={Fonts.MEDIUM}
            fontSize={20}
            y="58%"
            textAnchor="middle"
            dominantBaseline="middle"
          >
            {total}
          </text>
          <Pie
            label
            data={data}
            startAngle={90}
            endAngle={-270}
            dataKey="value"
            cx="50%"
            cy="50%"
            innerRadius="55%"
            outerRadius="72%"
            fill={cells[0]?.color || data[0]?.color}
          >
            {data.map((entry, index) => (
              <Cell key={index} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip
            labelStyle={{ color: "black" }}
            contentStyle={{
              borderRadius: 12,
              borderColor: "#31354188",
              background: "#FFFFFFCA",
            }}
          />
        </PieChart>
      </ResponsiveContainer>
    </StyledFlex>
  );
}
